module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "demo-export-excel"
    }
  }, [_vm._v("\n\texport excel\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d99705ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoExportExcel.vue
// module id = 3990
// module chunks = 1